(function() {
  $(document).ready(async function() {
    const selectors = {
      organizationSelect: '.charityBox__organizationSelect',
      fundrizerInput: '.charityBox__fundraizerInput',
      charityText: '.charityText',
      charityName: '.charityName',
      checkoutButton: '.checkoutButton',
      fundraizedCodeError: '.fundraizedCodeError',
      charitySubmitButton: '.charitySubmitButton',
      organizationError: '.organizationError',

      charityHiddenClass: 'charityText--hidden',
      codeErrorHiddenClass: 'fundraizedCodeError--hidden',
      charityInputError: 'charityBox__fundraizerInput--error',
      organizationErrorHidden: 'organizationError--hidden'
    };

    function debounce(fn, wait) {
      let t;

      return (...args) => {
        clearTimeout(t);

        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    async function updateCartAttributes(event) {
      const organizationSelect = document.querySelector(selectors.organizationSelect),
            charityText = document.querySelector(selectors.charityText),
            checkoutButton = document.querySelector(selectors.checkoutButton);

      event.target.disabled = true;
      checkoutButton.disabled = true;

      const updateResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            fundraiserCode: organizationSelect.selectedOptions[0].dataset.binded,
            organizationName: organizationSelect.selectedOptions[0].value,
            charityValue: charityText.dataset.charityPrice
          },
        }),
      });

      if(updateResponse.ok) {
        const fundraizedCodeError = document.querySelector(selectors.fundraizedCodeError);
        event.target.disabled = false;
        checkoutButton.disabled = false;
        window.charityTexts.selectedOrganization = organizationSelect.selectedOptions[0].value;
        fundraizedCodeError.classList.add(selectors.codeErrorHiddenClass);
      }
    }

    function validateOrganization(event) {
      if(!window.charityTexts.selectedOrganization) {
        const fundraizedCodeError = document.querySelector(selectors.fundraizedCodeError);
        event.preventDefault();
        event.currentTarget.disabled = true;
        fundraizedCodeError.classList.remove(selectors.codeErrorHiddenClass);
      }
    }

    function onOrganizationSelect(e) {
      const charityText = document.querySelector(selectors.charityText),
            charityOrganization = charityText.querySelector(selectors.charityName),
            selectedOption = e.currentTarget.selectedOptions[0],
            fundraizedCodeError = document.querySelector(selectors.fundraizedCodeError),
            charitySubmitButton = document.querySelector(selectors.charitySubmitButton),
            fundrizerInput = document.querySelector(selectors.fundrizerInput),
            organizationError = document.querySelector(selectors.organizationError);

      charityOrganization.innerText = selectedOption.innerText;
      fundrizerInput.value = selectedOption.dataset.binded;
      fundrizerInput.classList.remove(selectors.charityInputError);
      organizationError.classList.add(selectors.organizationErrorHidden);
      charityText.classList.remove(selectors.charityHiddenClass);
      fundraizedCodeError.classList.add(selectors.codeErrorHiddenClass);
      charitySubmitButton.disabled = false;
    }

    function onOrganizationInput(event) {
      const option = document.querySelector(`[data-binded="${event.target.value}"]`);
      const charitySubmitButton = document.querySelector(selectors.charitySubmitButton);
      const charityText = document.querySelector(selectors.charityText);
      const charityOrganization = charityText.querySelector(selectors.charityName);
      const organizationError = document.querySelector(selectors.organizationError);

      $(selectors.organizationSelect).val('');
      charitySubmitButton.disabled = true;
      charityText.classList.add(selectors.charityHiddenClass);
      organizationError.classList.add(selectors.organizationErrorHidden);
      event.target.classList.remove(selectors.charityInputError);

      if(option) {
        $(selectors.organizationSelect).val(`${option.value}`);
        charitySubmitButton.disabled = false;
        charityText.classList.remove(selectors.charityHiddenClass);
        charityOrganization.innerText = option.innerText;
      } else {
        organizationError.classList.remove(selectors.organizationErrorHidden);
        event.target.classList.add(selectors.charityInputError);
      }

      $(selectors.organizationSelect).trigger('change.select2');
    }

    const organizationsResponse = await fetch('https://api.givafifth.com/organisations?isActive=false');

    if(organizationsResponse.ok) {
      const checkoutButton = document.querySelector(selectors.checkoutButton);
      let organizations = await organizationsResponse.json();

      if(organizations.length > 0) {
        const organizationSelect = document.querySelector(selectors.organizationSelect),
              $select = $(selectors.organizationSelect),
              charitySubmitButton = document.querySelector(selectors.charitySubmitButton),
              fundrizerInput = document.querySelector(selectors.fundrizerInput);


        const organizationInputHandler = debounce((event) => {
          onOrganizationInput(event);
        }, 500)

        organizations.forEach(organization => {
          organizationSelect.innerHTML += `<option ${window.charityTexts.selectedOrganization == organization.fundraiserCode ? 'selected' : ''} data-binded="${organization.fundraiserCode}" value="${organization.name}">
          ${organization.name}${organization.city ? ' (' + organization.city : ''}${organization.state ? ', ' + organization.state + ')' : ''}
          </option>`;
        });

        fundrizerInput.addEventListener('input', event => {
          organizationInputHandler(event);
        });

        $select.select2({
          placeholder: window.charityTexts.organizationSelect,
          allowClear: true
        });

        $select.on("select2:select", function (e) {
          onOrganizationSelect(e);
        });

        charitySubmitButton.addEventListener('click',(event) => {
          event.preventDefault();
          updateCartAttributes(event);
        });
      }

      if(checkoutButton) {
        checkoutButton.addEventListener('click', (event) => {
          validateOrganization(event);
        });
      }
    }
  })
})();